import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { AppService } from '../../core/services/app.service';
import { formatNumber } from '@angular/common';
import { environment } from '../../../environments/environment';

@Directive({
    selector: '[appAmountCalculation]',
    standalone: false
})
export class AmountCalculationDirective implements OnInit, OnDestroy {
  @Input() amountPerUnit: UntypedFormControl;
  @Input() amount: UntypedFormControl;
  @Input() addedElementAmount$: BehaviorSubject<any>;
  @Input() isScaling: boolean;

  isAmountPerUnitViewEnabled: boolean;
  private _destroySubscriptions = new Subject();

  constructor(private _appService: AppService) { }

  ngOnInit() {
    this._appService.getIsAmountPerUnitView().pipe(takeUntil(this._destroySubscriptions))
      .subscribe(isEnabled => this.isAmountPerUnitViewEnabled = isEnabled);

    this.addedElementAmount$.pipe(takeUntil(this._destroySubscriptions)).subscribe(() => {
      if (this.isAmountPerUnitViewEnabled) {
        const amountPerUnit = this.amountPerUnit.value;

        const calculatedAmount = this.calculateAmount(amountPerUnit);
        this.amount.setValue(calculatedAmount);
      }
    });

    // Product amount change detection
    this.amountPerUnit.valueChanges.pipe(takeUntil(this._destroySubscriptions), filter(value => value != ''), debounceTime(500), distinctUntilChanged())
      .subscribe(amountPerUnit => {
        if (this.isAmountPerUnitViewEnabled || this.isScaling) {
          const calculatedAmount = this.calculateAmount(amountPerUnit);
          this.amount.setValue(calculatedAmount);
        }
      });

    // Product amount change detection
    this.amount.valueChanges.pipe(takeUntil(this._destroySubscriptions), debounceTime(500), distinctUntilChanged())
      .subscribe(amount => {
        if (!this.isAmountPerUnitViewEnabled) {
          const calculatedAmountPerUnit = this.calculateAmountPerUnit(amount);
          this.amountPerUnit.setValue(calculatedAmountPerUnit);
        }
      });
  }

  ngOnDestroy(): void {
    this._destroySubscriptions.next(undefined);
    this._destroySubscriptions.complete();
  }

  calculateAmount(amountPerUnit: string | number) {
    const elementAmount = this.amountParsing(this.addedElementAmount$.getValue());
    amountPerUnit = this.amountParsing(amountPerUnit);

    amountPerUnit = (elementAmount || 1) * (amountPerUnit || 1);
     return parseFloat(amountPerUnit.toFixed(2)).toString().replace('.', ',');
  }

  calculateAmountPerUnit(amount: string | number) {
    const elementAmount = this.amountParsing(this.addedElementAmount$.getValue());
    amount = this.amountParsing(amount);
    amount = (amount || 1) / (elementAmount || 1);
    return parseFloat(amount.toFixed(2)).toString().replace('.', ',');
  }

  amountParsing(amountValue: any): number {
    const amount: string = typeof amountValue === 'string' ? amountValue : '' + amountValue;
    return parseFloat(amount.replace(',', '.')) || 0; 
  }

}
